import { BirdviewChartTone } from '../../DashboardBirdview.constants.charts'

export const BIRDVIEW_CHART_STACKED_SEGMENTS = [
  {
    color: BirdviewChartTone.Info,
    key: 'open',
    labelKey: 'DashboardBirdview.ChartOpenLegendKey',
  },
  {
    color: BirdviewChartTone.Error,
    key: 'overdue',
    labelKey: 'DashboardBirdview.TileOverdueKey',
  },
  {
    color: BirdviewChartTone.Success,
    key: 'closed',
    labelKey: 'DashboardBirdview.ChartClosedLegendKey',
  },
]
